import moment, { Moment } from 'moment';

export const daysInMonth = (month: Moment): Moment[] =>
  Array.from({ length: month.daysInMonth() }, (_, i) =>
    moment(month).startOf('month').add(i, 'days'),
  );
